/** Pointer type */
export enum PointerType {
  /** Low pointer */
  Min,
  /** High pointer */
  Max
}
